import { useZodForm } from "popopo-lib-front/zod-form"
import { z } from "zod/v4"
import { LoadingButton, ManagedCheckbox } from "popopo-lib-front/component"
import { Stack } from "react-bootstrap"
import { UserPushSettingDocumentBody } from "popopo-msg"
import { api } from "../../core"
import { User } from "firebase/auth"
import { useState } from "react"
import { useToast } from "popopo-lib-front/hook"

export const UserPushSettingForm = (props: {
  currentSettings: UserPushSettingDocumentBody | null,
  firebase: User
}) => {
  const toast = useToast()
  const form = useZodForm({
    schema: z.object({
      acceptPushOfOthers: z.boolean(),
      acceptPushOfHistory: z.boolean(),
      acceptPushOfFollowingUserActions: z.boolean(),
      acceptCall: z.boolean(),
      acceptSuperCall: z.boolean(),
    }),
    defaultValues: {
      acceptPushOfOthers: props.currentSettings?.accept_push_of_others ?? true,
      acceptPushOfHistory: props.currentSettings?.accept_push_of_history ?? true,
      acceptPushOfFollowingUserActions: props.currentSettings?.accept_push_of_following_user_actions ?? true,
      acceptCall: props.currentSettings?.accept_call ?? true,
      acceptSuperCall: props.currentSettings?.accept_super_call ?? true,
    }
  })
  const { isValid } = form.formState

  const [isSubmitting, setIsSubmitting] = useState(false)

  return (
    <form onSubmit={form.handleSubmit(async (data) => {
      setIsSubmitting(true)
      try {
        const res = await api.PUT("/api/v2/users/me/push-setting", {
          body: data,
          headers: {
            authorization: `Bearer ${await props.firebase.getIdToken()}`
          }
        })
        if (res.data == null) {
          toast.add({
            type: "danger",
            title: "Push設定の更新に失敗しました",
            message: JSON.stringify(res.error)
          })
        } else {
          toast.add({
            type: "success",
            title: "Push設定",
            message: "更新しました"
          })
        }
      } catch (e) {
        console.error(e)
        toast.add({
          type: "danger",
          title: "Push設定の更新に失敗しました",
          message: e.message
        })
      } finally {
        setIsSubmitting(false)
      }
    })}>
      <Stack>
        <ManagedCheckbox control={form.control} name="acceptPushOfOthers" checkboxLabel="その他の通知を受信する" />
        <ManagedCheckbox control={form.control} name="acceptPushOfHistory" checkboxLabel="スペースに関するプッシュ通知を受信する" />
        <ManagedCheckbox control={form.control} name="acceptPushOfFollowingUserActions" checkboxLabel="フォロー中ユーザーに関するプッシュ通知を受信する" />
        <ManagedCheckbox control={form.control} name="acceptCall" checkboxLabel="コールを受信する" />
        <ManagedCheckbox control={form.control} name="acceptSuperCall" checkboxLabel="スーパーコールを受信する" />
        <LoadingButton isLoading={isSubmitting} isValid={isValid}>
          更新
        </LoadingButton>
      </Stack>
    </form>
  )

}
